export function hasValidImageExtension(fileName: string): boolean {
  const supportedExtensions = ['.jpg', '.jpeg', '.png'];
  const result = supportedExtensions.filter((ext) => fileName.endsWith(ext));
  return result.length > 0;
}
